var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sharing-sharee-list"},_vm._l((_vm.shares),function(share){return _c('SharingEntry',{key:share.id,attrs:{"file-info":_vm.fileInfo,"share":share,"is-unique":_vm.isUnique(share)},on:{"open-sharing-details":function($event){return _vm.openSharingDetails(share)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }